import { Component, EventEmitter, Output } from '@angular/core';
import { faExternalLink, IconDefinition, faChartLine, faBrain} from '@fortawesome/free-solid-svg-icons';
import { NavIconService } from '../../Services/NavIcon.service';
import { navList } from '../../../../constants/constants';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  @Output() public isMenuOpened = new EventEmitter();
  public navigationList: any[] = navList;
  public environmentName: string;
  public dataVizUrl: string;
  public sentimentAnalyzerUrl: string;

  //icons
  public faExternalLink = faExternalLink;
  public faBarChart = faChartLine;
  public faBrain = faBrain;

  constructor(
      private route : Router,
      private navIconService: NavIconService) { 
        this.environmentName = environment.environmentName;
        this.dataVizUrl = environment.DATA_VIZ_URL;
        this.sentimentAnalyzerUrl = environment.SENTIMENT_ANALYZER_URL;
  }

    getIcon(iconName: string): IconDefinition {
       return this.navIconService.getIcon(iconName);
    }

  navigateToRoute(route: string): void {
    this.route.navigate([route]);
    this.isMenuOpened.emit(false);
  }
}
